var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.11 3.99c3.025.716 5.39 3.246 5.39 6.436v4.014",
    stroke: "#737680",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05 12.79s-3.3 1.1-3.3 2.255c0 1.32 4.675 3.025 7.48 3.025 3.025 0 8.085-4.235 8.085-4.235",
    stroke: "#737680",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 13.34s-1.98 1.485-6.6 1.485c-4.62 0-6.6-1.484-6.6-1.484v-2.915c0-3.63 2.97-6.6 6.6-6.6 3.63 0 6.6 2.97 6.6 6.6v2.915z",
    stroke: "#737680",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHat);
export default __webpack_public_path__ + "static/media/icon-hat.574e70dae3e9e98edda79c525b4ad6e5.svg";
export { ForwardRef as ReactComponent };